import { render, staticRenderFns } from "./AddingInvoiceProductPopup.vue?vue&type=template&id=c88ef396"
import script from "./AddingInvoiceProductPopup.vue?vue&type=script&lang=js"
export * from "./AddingInvoiceProductPopup.vue?vue&type=script&lang=js"
import style0 from "./AddingInvoiceProductPopup.vue?vue&type=style&index=0&id=c88ef396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports